module.exports = {"id":"189225","name":"Bruno Fornaroli","rating":"76","photo":"./data/images/photos/0/189225.png","club":{"name":"Melbourne City","logo":"./data/images/clubs/MelbourneCity.png"},"positions":["BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BrunoFornaroli0.json
// module id = 658
// module chunks = 0